import { defineMessages } from 'react-intl';

export default defineMessages({
  switchButton: {
    id: 'lsaKHP',
    description: 'Button text to switch all rules to ParcelGuard',
    defaultMessage: 'Switch All to ParcelGuard',
  },
  noCarrierRulesError: {
    id: 'x2GZmP',
    description: 'Error message when no carrier insurance rules are found',
    defaultMessage: 'No carrier insurance rules found to update.',
  },
  rulesUpdatedSuccess: {
    id: 'EWlaAs',
    description: 'Success message after switching rules to ParcelGuard',
    defaultMessage: 'The insurance selections on your rules have been updated to ParcelGuard.',
  },
  rulesUpdatedTitle: {
    id: 'f+uPXN',
    description: 'Title message after switching rules to ParcelGuard',
    defaultMessage: 'Automation rules updated',
  },
  rulesUpdateErrorTitle: {
    id: 'FB/khd',
    description: 'Title message for errors when switching rules to ParcelGuard',
    defaultMessage: 'Unable to update automation rules',
  },
  rulesUpdateError: {
    id: 'ao/s9F',
    description: 'Error message when updating rules fails',
    defaultMessage: 'Failed to update automation rules. Please try again.',
  },
});
